import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
declare const require: any;

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {

  constructor() { }

  setSessionValuesFromQueryString(): void {
    parent.postMessage('GetAccessToken', '*');

    const queryString = require('query-string');
    const parsedQueryString = queryString.parse(location.search);
    if (!!parsedQueryString.organizationid) {
      sessionStorage.setItem('organizationid', parsedQueryString.organizationid);
      environment.authSettings.organizationId = sessionStorage.getItem('organizationid');
    }
    if (!!parsedQueryString.systemGUID) {
      sessionStorage.setItem('systemGUID', parsedQueryString.systemGUID);
    }
    if (!!parsedQueryString.customerId) {
      sessionStorage.setItem('customerId', parsedQueryString.customerId);
    }
  }
}
